import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { finalize, takeUntil, tap } from 'rxjs';

import {
  GetCalenderByMonthAndYearDto,
  GetEnumValuesDto,
} from 'src/app/core/api/models';
import { CalendersService, EnumsService } from 'src/app/core/api/services';
import { DateConverterPipe } from 'src/app/core/pipes/date-converter.pipe';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { UtilService } from 'src/app/core/services/util.service';
import { TranslationModule } from 'src/app/i18n/translation.module';
import { BasePageComponent } from 'src/app/pages/shared/base/components/base-page.component';
import { PagesSharedModule } from 'src/app/pages/shared/pages-shared.module';
import { FieldSearcherModule } from 'src/app/shared/global/field-searcher/field-searcher.module';
import { MaterialModule } from 'src/app/shared/modules/material/material.module';
import { CalendarCardComponent } from '../calendar-card/calendar-card.component';
import { CalenderFilterDaysPipe } from '../calender-filter-days.pipe';
import { CalenderData } from './calender-data.model';
import { YearsModalComponent } from './years-modal/years-modal.component';
@Component({
  selector: 'app-calender',
  templateUrl: './calender.component.html',
  imports: [
    CommonModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    TranslationModule,
    ReactiveFormsModule,
    FormsModule,
    PagesSharedModule,
    MatFormFieldModule,
    MatInputModule,
    CalendarCardComponent,
    FieldSearcherModule,
    CalenderFilterDaysPipe,
  ],
  providers: [DateConverterPipe],
})
export class CalenderComponent extends BasePageComponent implements OnInit {
  //#region Properties

  year: number;
  month: number;
  loading: boolean = false;
  @Input() items: CalenderData[] = [];
  @Input() getCalenderDataFromServer: boolean = true;
  @Input() daySelectable: boolean = false;
  selectedDayInfo: GetCalenderByMonthAndYearDto = {};
  monthName: string = '';
  disableNextMonthBtn: boolean = false;
  disablePreviousMonthBtn: boolean = false;
  isChangeMonth: boolean = false;
  todayDate: string = '';
  selectedId: number;
  isLoading: boolean = true;
  displayableMonths: GetEnumValuesDto[] = [];
  @Input() isGetCalender: boolean = false;

  @Output('dayInfo') output_dayInfo =
    new EventEmitter<GetCalenderByMonthAndYearDto>();
  @Output('calenderLoading') output_calenderLoading = new EventEmitter<boolean>(
    true
  );
  @Output('isGetCalender') output_isGetCalender = new EventEmitter<boolean>();

  //#region Properties

  constructor(
    protected currentService: CalendersService,
    protected dateConverter: DateConverterPipe,
    public dialogService: DialogService,
    public enumService: EnumsService
  ) {
    super();
  }

  ngOnInit() {
    this.output_calenderLoading.emit(true);
    this.initModel();
    this.getCalendar();
    let date = DateTimeService.toUTC(DateTimeService.getSimpleTodayDate());
    this.todayDate = this.dateConverter.transform(date, 'fa');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isGetCalender) this.getCalendar();
  }

  toggleSelectDay(calenderData: CalenderData) {
    if (!this.daySelectable || calenderData.disabled) return;
    if (!calenderData.selected) calenderData.selected = true;
    else calenderData.selected = false;
  }

  initModel() {
    let currentYear = DateTimeService.getCurrentShamsiYear();
    let currentMonth = DateTimeService.getCurrentShamsiMonth();
    this.year = Number(currentYear);
    this.month = Number(currentMonth);
    this.getMonthName();
  }

  /**  Get Calender */
  getCalendar() {
    if (!this.getCalenderDataFromServer) {
      this.isLoading = false;
      this.loading = false;
      this.output_calenderLoading.emit(false);
      return;
    }
    this.isLoading = true;

    this.currentService
      .calendersGetCalenderByMonthAndYear({
        Month: this.month,
        Year: this.year,
      })
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => (this.loading = false))
      )
      .subscribe((result) => {
        this.isLoading = false;
        this.items = result.data.map((c) => ({ ...c, selected: false }));
        if (this.selectedDayInfo?.id) {
          this.onChangeSelectedDay(this.selectedDayInfo?.solarDate);
        } else this.onChangeSelectedDay(this.todayDate);

        this.isGetCalender = false;
        this.output_calenderLoading.emit(this.isGetCalender);
        this.output_isGetCalender.emit(this.isGetCalender);
      });

    this.disableBtn();
  }

  /**  Get PersianMonth Enum Values By key */
  getMonthName() {
    this.enumService
      .enumsGetEnumValues({ EnumTypeName: 'PersianMonth' })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((res) => {
        if (this.getCalenderDataFromServer)
          this.monthName = res.data?.find(({ key }) => key == this.month).value;
        else {
          let existsMonths = [];
          this.items.forEach((item) => {
            if (!existsMonths.includes(item.month))
              existsMonths.push(item.month);
          });
          this.displayableMonths = res.data.filter((f) =>
            existsMonths.includes(f.key)
          );
          this.month = existsMonths[0];
          this.getMonthNameFromDisplayableMonths();
        }
      });
  }

  onChangeMonth(event) {
    this.month = +event.target.value;
    this.getMonthNameFromDisplayableMonths();
  }

  getMonthNameFromDisplayableMonths() {
    this.monthName = this.displayableMonths?.find(
      ({ key }) => key == this.month
    ).value;
  }

  /**  gives us the information of the days */
  onChangeSelectedDay(selectedDay) {
    if (!this.isChangeMonth) {
      this.selectedDayInfo = this.items.find(
        (item) => item?.solarDate == selectedDay
      );
    } else {
      this.selectedDayInfo = this.items.find((item) => item?.day == 1);
    }
    this.selectedId = this.selectedDayInfo?.id;

    this.output_dayInfo.emit(this.selectedDayInfo);

    this.isChangeMonth = false;
  }

  /**  Get PersianMonth Enum key */
  getComparisonItem(event) {
    this.month = event.value;
    this.isChangeMonth = true;

    this.getMonthName();
    this.getCalendar();
  }

  /**  open Modal to select the year */
  onShowYearsModal(year) {
    if (this.getCalenderDataFromServer) return;
    const modalResult = this.dialogService.openModal({
      component: YearsModalComponent,
      data: {
        year: year,
      },
    });
    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((res) => {
        if (res) {
          this.year = res;
          this.isChangeMonth = true;
          this.getCalendar();
        }
      });
  }

  nextMonth() {
    if (this.disableNextMonthBtn) return;

    if (!this.getCalenderDataFromServer) {
      let month;
      if (this.month == 12) month = 1;
      else month = this.month + 1;
      if (this.displayableMonths.find((m) => m.key == month)) {
        this.month = month;
        this.getMonthNameFromDisplayableMonths();
      }
      return;
    }

    this.month = +this.month + 1;
    this.isChangeMonth = true;

    this.getCalendar();
    this.getMonthName();
  }

  previousMonth() {
    if (this.disablePreviousMonthBtn) return;
    if (!this.getCalenderDataFromServer) {
      let month;
      if (this.month == 1) month = 12;
      else month = this.month - 1;
      if (this.displayableMonths.find((m) => m.key == month)) {
        this.month = month;
        this.getMonthNameFromDisplayableMonths();
      }
      return;
    }

    this.month = +this.month - 1;
    this.isChangeMonth = true;

    this.getCalendar();
    this.getMonthName();
  }

  /** Create array from number */
  getRange(num: number): number[] {
    return UtilService.getRange(num);
  }

  /** check whether the next month button or the previous month button is disabled or not */
  disableBtn() {
    // PreviousMonthBtn
    if (this.month == 1) this.disablePreviousMonthBtn = true;
    else this.disablePreviousMonthBtn = false;

    // NextMonthBtn
    if (this.month == 12) this.disableNextMonthBtn = true;
    else this.disableNextMonthBtn = false;
  }

}
